<template>
  <div class="home flexBox" v-if="isAll">
    <van-nav-bar
      :style="{ background: `${sessionStorage.colorCode} !important` }"
      class="flexNone"
      :title="$t('Dishes.title')"
      left-arrow
      fixed
      @click-left="$router.push('/setMenu')"
    >
    </van-nav-bar>
    <div class="menuContent" v-if="dishes" @click.stop>
      <van-sidebar v-model="activeKey" @change="changeKey()">
        <draggable
          v-model="dishes"
          chosen-class="chosen"
          force-fallback="true"
          group="people"
          @start.stop="onStart"
          @end.stop="onEnd"
          :move="onMove"
        >
          <transition-group name="sort">
            <div class="item" v-for="(dish, index) in dishes" :key="dish.id">
              <van-sidebar-item
                v-if="dish.status"
                :title="dish.name"
                :style="
                  activeKey == index
                    ? {
                        'background-color': sessionStorage.colorCode,
                        'border-color': sessionStorage.colorCode
                      }
                    : {}
                "
              ></van-sidebar-item>
            </div>
          </transition-group>
        </draggable>
      </van-sidebar>

      <div class="dishContent">
        <template v-if="actMenus.length > 0">
          <draggable
            v-model="actMenus"
            handle=".dragIcon"
            chosen-class="chosen"
            force-fallback="true"
            group="people"
            @start.stop="onStart"
            @end.stop="onEnd"
            :move="onMove"
          >
            <transition-group name="sort">
              <div v-for="menu in actMenus" :key="menu.id" class="dishItem">
                <div class="drag_icon">
                  <van-icon name="./static/img/drag.png" class="dragIcon" />
                </div>
                <template v-if="menu.image">
                  <van-image class="menuImg" :src="menu.image.path" />
                </template>
                <template v-else>
                  <van-image class="menuImg" :src="image.path" />
                </template>
                <div
                  class="itemInfo"
                  @click.stop="
                    menu.category == 'm'
                      ? $router.push('/DishDetail/' + menu.id)
                      : $router.push('/PackageDetail/' + menu.id)
                  "
                >
                  <div class="leftInfo">
                    <div class="fontLine Bigfont">{{ menu.name }}</div>
                    <div class="fontLine Subname">{{ menu.name_en }}</div>
                    <div class="fontLine Subname" v-if="menu.introduction">
                      {{ menu.introduction }}
                    </div>
                    <div style="height: 5px;"></div>
                    <div class="dishItem_footer">
                      <div class="fontLine">
                        <span class="currentPrice">
                          {{ currency }}
                          {{
                            menu.type == "o"
                              ? menu.original_price
                              : menu.special_price
                          }}</span
                        >&nbsp;&nbsp;&nbsp;<span
                          class="oldPrice"
                          v-show="
                            menu.type == 's' && menu.original_price != null
                          "
                          >{{ currency }}{{ menu.original_price }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </transition-group>
          </draggable>
        </template>
        <template v-else>
          <div style="text-align: center;line-height: 80px;">
            {{ $t("Dishes.noneGoods") }}
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
export default {
  components: {
    draggable
  },
  data() {
    return {
      activeKey: 0,
      isShopCartShow: false,
      dishes: [],
      actMenus: [],
      shopCart: {},
      packages: {},
      count: 4,
      isAll: false,
      allNum: 0,
      outNum: 0,
      currency: "",
      target_id: 0,
      pivot_id: 0,
      to_pivot_id: 0,
      data: null,
      drag: false,
      startItem: null,
      endItem: null,
      image: {}
    };
  },
  mounted: function() {
    this.getDishes();
    this.getCurrency();
    this.getActiveKey();
    if (sessionStorage.getItem("store_image")) {
      this.image = JSON.parse(sessionStorage.getItem("store_image"));
    } else {
      this.getStore();
    }
  },
  methods: {
    // 获取店铺商标
    getStore() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + `/api/store/${sessionStorage.actShopId}/show`
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.image = res.data.data.image;
            sessionStorage.setItem(
              "store_image",
              JSON.stringify(res.data.data.image)
            );
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getDishes() {
      // 获取
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url:
          this.$build +
          "/api/store/" +
          sessionStorage.actShopId +
          "/totalMenus/in"
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.dishes = [];
            for (var i = 0; i < res.data.data.length; i++) {
              if (res.data.data[i].status) {
                this.dishes.push(res.data.data[i]);
              }
            }
            this.dishes.forEach(item => {
              if (item.status == 1) {
                item.status = true;
              } else {
                item.status = false;
              }
            });
            if (this.dishes[this.activeKey]) {
              this.actMenus = this.dishes[this.activeKey].menus;
            } else {
              this.activeKey = 0;
              sessionStorage.setItem("activeKey", this.activeKey);
              this.actMenus = this.dishes[this.activeKey].menus;
            }
            this.isAll = true;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("Dishes.message")
          });
        });
    },
    changeKey() {
      console.log(this.activeKey);
      sessionStorage.setItem("activeKey", this.activeKey);
      this.actMenus = this.dishes[this.activeKey].menus;
      console.log(this.dishes);
      console.log(this.actMenus);
    },
    // 保存上次选择的tab栏选项
    getActiveKey() {
      if (sessionStorage.getItem("activeKey")) {
        this.activeKey = Number(sessionStorage.getItem("activeKey"));
      } else {
        this.activeKey = 0;
      }
    },
    // 获取店铺设置的货币
    getCurrency() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url:
          this.$build + "/api/store/" + sessionStorage.actShopId + "/currency"
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.currency = res.data.data.unit;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("EditDish.message")
          });
        });
    },
    //更改套餐或套餐单品
    Sort(value) {
      let url = "";
      if (value.pivot) {
        url = this.$build + "/api/menu/upDown";
      } else {
        url = this.$build + "/api/tags/order";
      }
      this.$axios({
        method: "PATCH",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: url,
        data: this.data
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            if (value.pivot) {
              var temp = JSON.parse(JSON.stringify(this.dishes[this.sortKey]));
              temp.menus = res.data.data;
              this.actMenus = res.data.data;
              this.$set(this.dishes, this.sortKey, temp);
            } else {
              this.getDishes();
            }
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
          this.startItem = null;
          this.endItem = null;
          this.$toast.clear();
        })
        .catch(err => {
          this.$toast.clear();
          this.$toast({
            type: "fail",
            message: this.$t("EditDish.message")
          });
        });
    },
    onStart(e) {
      this.drag = true;
      this.sortKey = this.activeKey;
      console.log(e, "开始");
    },
    onEnd(e) {
      this.drag = false;
      if (this.startItem && this.startItem.pivot) {
        this.target_id = this.startItem.pivot.target_id;
        this.data = {
          pivot_id: this.startItem.pivot.id,
          target_id: this.startItem.pivot.target_id,
          pivot_ids: this.endItem.pivot.id
        };
      } else if (this.startItem && this.endItem) {
        this.data = {
          id: this.startItem.id,
          ids: this.endItem.id
        };
      }
      if (this.startItem) {
        this.Sort(this.startItem);
      }
    },
    onMove(e, originalEvent) {
      //拖拽位置
      this.startItem = e.draggedContext.element;
      //停靠位置
      this.endItem = e.relatedContext.element;
      if (e.draggedContext.element) return false;
    }
  }
};
</script>
<style scoped>
/deep/ .van-nav-bar .van-icon {
  font-size: 24px;
  color: #fff;
}
/deep/ .van-sidebar {
  width: 25%;
  height: 100%;
  background-color: #bbbbbb;
  float: left;
  overflow: auto;
}
/deep/ .van-sidebar-item {
  text-align: center;
  padding: 10px 10px 10px 8px;
  background-color: #fff;
  border-bottom: 1px solid #eee;
  margin: 15px 10px 15px 0px;
  border-radius: 0px 50px 50px 0px;
}
/deep/.van-sidebar-item--select::before {
  background: none;
}
/deep/ .van-sidebar-item--select {
  color: #fff;
  border-color: #000;
  background-color: #000;
}

.van-button__text {
  color: #222;
}

.home {
  width: 100%;
  height: 100vh;
  background-color: #f3f3f3;
}
.menuContent {
  width: 100%;
  min-height: 170px;
  flex: auto;
  /* padding-top: 46px; */
}
.dishContent {
  width: 75%;
  height: 100%;
  float: right;
  overflow: hidden;
  overflow-y: auto;
  margin-top: 2px;
  background-color: #fff;
}
.dishItem {
  width: calc(100% - 16px);
  margin: 10px 20px;
  height: 100px;
  background-color: #fff;
  border-radius: 5px;
  position: relative;
  display: flex;
  overflow: hidden;
}
.itemInfo {
  flex: auto;
  display: -webkit-flex; /* Safari */
  display: flex;
  flex-direction: column;
  width: 34%;
}
.leftInfo {
  margin-left: 10px;
  width: 100%;
  height: 80px;
  font-size: 14px;
}
.fontLine {
  width: 80%;
  height: 20px;
  line-height: 20px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.icons {
  display: flex;
  /*width: 80px;*/
  position: absolute;
  bottom: -2px;
  right: 5px;
}
.drag_icon {
  height: 70px;
}
.itemIcon {
  margin-right: 20px;
  text-align: right;
}
.enterIcon {
  position: absolute;
  top: 15px;
  right: 5px;
}
.flexBox {
  display: -webkit-flex; /* Safari */
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.flexNone {
  flex: none;
}
.currentPrice {
  color: #fc1617;
  font-size: 18px;
  font-weight: 600;
}
.oldPrice {
  color: #bcbcbc;
  text-decoration: line-through;
}
.cart_left {
  width: 60%;
  height: 34px;
  line-height: 34px;
  float: left;
}
.cart_right {
  width: 40%;
  height: 34px;
  line-height: 34px;
  float: right;
  text-align: right;
}
.cart_right_btn {
  height: 34px;
  line-height: 34px;
  font-size: 16px;
  color: #222;
}
.total_price {
  width: 120px;
  height: 34px;
  line-height: 34px;
  text-indent: 10px;
  font-size: 16px;
}
.cartDetail {
  width: 100%;
  height: auto;
}
.cartItem {
  width: 90%;
  margin-left: 5%;
  position: relative;
}
.leftdot {
  position: absolute;
  width: 6px;
  height: 6px;
  left: -3.5%;
  top: 15px;
  background: linear-gradient(to right, #ffc914, #ffc813);
  border-radius: 50%;
}
.cart_dish {
  width: 100%;
}
.cart_dish_name {
  width: 80%;
  height: 35px;
  line-height: 35px;
}
.cart_dish_price {
  width: 20%;
  height: 35px;
  line-height: 35px;
  text-align: right;
  color: #aaa;
}
.cart_dish_des {
  width: 100%;
  height: 20px;
  line-height: 20px;
  font-size: 13px;
  color: #ccc;
}
.son_dish {
}
.son_dish > .cart_dish_name {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
}
.son_dish > .cart_dish_price {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
}
.son_dish > .cart_dish_des {
  height: 18px;
  line-height: 18px;
  font-size: 12px;
}
.icon_group {
  padding-top: 10px;
  width: 100%;
  height: 35px;
  line-height: 35px;
  clear: both;
}
.realPrice {
  color: #000;
}
.rightIcon {
  position: absolute;
  right: 5px;
  top: 5px;
}
.menuImg {
  width: 70px;
  height: 70px;
  position: relative;
  border-radius: 5px;
  overflow: hidden;
}
.sort-move {
  transition: transform 0.3s;
}
.dragIcon {
  position: relative;
  top: 20px;
  right: 5px;
  cursor: move;
}
.Bigfont {
  font-size: 17px;
  font-weight: 600;
}
.Subname {
  font-size: 12px;
  color: #bbbbbb;
  margin-top: 2px;
}
.dishItem_footer {
  display: flex;
  align-items: end;
}
</style>



// WEBPACK FOOTER //
// src/Shop/Dishes.vue